import styled from "styled-components";
import BreakPointsFontsMedia from "../../utils/BreakPointsFontsMedia";
import DS from "../DS";
import {
  BaseTypoCSS,
  BaseTypoProps,
} from "./BaseTypo";

const H4 = styled.p<BaseTypoProps>`
  ${BaseTypoCSS({
    fontFamily: "NeueHaasUnica",
  })}
  font-style: normal;
  font-size: 18px;
  line-height: 30px;
  letter-spacing: 0;
  font-weight: 500;
  ${BreakPointsFontsMedia(
    DS.breakpoints,
    26,
    18,
    10
  )};
`;

export default H4;
